import { FAQItem } from '../types/faq';

export const FAQ_ITEMS: FAQItem[] = [
  {
    question: 'Como funciona a leitura astrológica?',
    answer: 'Nossa leitura astrológica é baseada em seu mapa astral completo, calculado a partir de sua data, hora e local de nascimento. Analisamos as posições dos planetas, aspectos e casas astrológicas para fornecer insights personalizados.'
  },
  {
    question: 'Quanto custam os serviços?',
    answer: 'Oferecemos diferentes pacotes de créditos, começando com o plano básico de R$ 29,90. Você pode usar seus créditos para consultas, mapas astrais e outros serviços. Também temos a opção pré-paga para maior flexibilidade.'
  },
  {
    question: 'Como faço para agendar uma consulta?',
    answer: 'Para agendar uma consulta, primeiro escolha um consultor na seção "Consultores". Você pode optar por chat ao vivo, consulta por email ou um estudo completo. Basta selecionar o serviço desejado e seguir as instruções de agendamento.'
  },
  {
    question: 'Os créditos expiram?',
    answer: 'Não, seus créditos não expiram e podem ser usados a qualquer momento. Você pode acompanhar seu saldo de créditos em seu perfil.'
  },
  {
    question: 'Como funciona o sistema de recompensas?',
    answer: 'Nosso sistema de recompensas oferece pontos por cada interação na plataforma. Você pode ganhar pontos fazendo consultas, compartilhando experiências e convidando amigos. Os pontos podem ser trocados por créditos e benefícios exclusivos.'
  },
  {
    question: 'Posso solicitar reembolso?',
    answer: 'Sim, oferecemos reembolso em até 7 dias após a compra, desde que os créditos não tenham sido utilizados. Entre em contato com nosso suporte para solicitar.'
  },
  {
    question: 'Como garantem a precisão das informações?',
    answer: 'Nossos astrólogos são profissionais certificados com anos de experiência. Utilizamos software astronômico preciso para cálculos e nossa equipe passa por treinamento contínuo para garantir a qualidade das interpretações.'
  },
  {
    question: 'Qual a diferença entre os tipos de consulta?',
    answer: 'Oferecemos chat ao vivo para respostas rápidas, consultas por email para análises mais detalhadas, e estudos completos que incluem seu mapa astral detalhado com previsões para os próximos 12 meses.'
  }
];